/* eslint-disable no-nested-ternary */
import * as React from 'react';

import LevelEsencialVertical from 'crehana-icons/LevelEsencialVertical';
import LevelIntermediateVertical from 'crehana-icons/LevelIntermediateVertical';
import LevelCompleteVertical from 'crehana-icons/LevelCompleteVertical';
import LevelCompleteCircle from 'crehana-icons/LevelCompleteCircle';

import Text from 'crehana-ui/Text';

import { CourseCardProps } from 'Jsx/Shared/CourseCardV3/types';
import { primaryColor } from 'crehui/styles/colors';

export const courseType = typeLevel => {
  if (typeLevel === 'completo' || typeLevel === 'Completo') {
    return <LevelCompleteCircle size={19} color={primaryColor} />;
  }
  if (typeLevel === 'Esencial' || typeLevel === 'esencial') {
    return <LevelEsencialVertical size={24} color={primaryColor} />;
  }
  if (typeLevel === 'Intermedio' || typeLevel === 'intermedio') {
    return <LevelIntermediateVertical size={24} color={primaryColor} />;
  }
  if (typeLevel === 'Avanzado' || typeLevel === 'avanzado') {
    return <LevelCompleteVertical size={24} color={primaryColor} />;
  }
};

const Level: React.FC<Partial<CourseCardProps>> = props => {
  const { level } = props;
  const levelName = level && level.name && level.name.toLowerCase();

  if (!levelName) {
    return null;
  }

  return (
    <div
      className="LevelComponent flex items-center"
      css={`
        padding: ${levelName ? '18px 0 12px' : '14px 0 12px'};
      `}
    >
      <div className="flex items-center">
        {courseType(levelName)}
        <Text type="body4" color="gray-dark" className="font-bold ml-8">
          {`${
            levelName === 'completo'
              ? 'Completo'
              : `Nivel ${
                  levelName === 'esencial'
                    ? 'Introductorio'
                    : level && level.name
                }`
          }`}
        </Text>
      </div>
    </div>
  );
};

export default Level;
